import { notification } from 'antd';

export default function OpenNotification(type, message, description) {
  return notification[type]({
    message: message,
    description: description
  });
};